import {
    LOAD_APPLICATIONS,
    LOAD_APPLICATIONS_SUCCESS,
    CREATE_APPLICATION_REQUEST,
    SET_CREATE_APPLICATION_LOADING,
    REQUEST_DELETE_APPLICATION
} from './constants'

export function loadApplications() {
    return {
        type: LOAD_APPLICATIONS,
        payload: {}
    }
}

export function setApplicationPage({ applications }) {
    return {
        type: LOAD_APPLICATIONS_SUCCESS,
        payload: {
            applications
        }
    }
}

export function createApplication({ name }) {
    return {
        type: CREATE_APPLICATION_REQUEST,
        payload: {
            name
        }
    }
}

export function setCreateApplicationLoading(value = false) {
    return {
        type: SET_CREATE_APPLICATION_LOADING,
        payload: value
    }
}

export function requestDeleteApplication() {
    return {
        type: REQUEST_DELETE_APPLICATION,
        payload: {}
    }
}
